import { productAnchors } from "@/mocks/site";

export default function StickyAnchors() {
  return (
    <div className="sticky top-[73px] z-30 border-y border-foreground-200 bg-background-100/95 backdrop-blur md:top-[87px]">
      <div className="mx-auto flex w-full max-w-shell items-center gap-1 overflow-x-auto px-4 md:px-6">
        <span className="hidden flex-none py-3 pr-3 font-label text-[10px] uppercase tracking-[0.2em] text-foreground-400 lg:block">
          Bereiche
        </span>
        {productAnchors.map((anchor) => (
          <a
            key={anchor.href}
            href={anchor.href}
            className="flex-none whitespace-nowrap border-b-2 border-transparent px-3 py-3 font-label text-[10.5px] uppercase tracking-[0.14em] text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-700 md:px-4 md:text-[11px]"
          >
            {anchor.label}
          </a>
        ))}
      </div>
    </div>
  );
}